import { IonBackButton, IonButtons, IonCol, IonContent, IonGrid, IonPage, IonRow, IonTitle, isPlatform } from "@ionic/react";
import { useLiveQuery } from "dexie-react-hooks";
import React, { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import { CustomLoading, Header } from "../../components";
import { db } from "../../data/db/db";
import { URLParamToArray } from "../article/articleHelper";

import "./ArticleDetail.scss"

interface ArticleDetailProps extends RouteComponentProps<{
    id: string
}> { }

const ArticleDetail: React.FC<ArticleDetailProps> = ({ history, match }) => {
    const articleStr = match.params.id;
    const [ident, setIdent] = useState<string[] | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setIdent(URLParamToArray(articleStr))

        return () => {
            //unmount
            setIdent(null);
        }

    }, [articleStr])


    const articles = useLiveQuery(
        async () => {
            if (ident) {
                setLoading(true);
                const articles = await db.articlesOverview
                    .where('ident')
                    .anyOf(ident)
                    .toArray()
                setLoading(false)
                // Return result
                return articles;
            }

        },
        [ident]
    );

    return (
        <IonPage>
            <Header>
                <IonButtons slot="start">
                    <IonBackButton defaultHref="/tabs/article" text={isPlatform('ios') ? "Zurück" : undefined} />
                </IonButtons>
                <IonTitle>Details</IonTitle>
            </Header>
            <IonContent>
                <IonGrid fixed={true} className="mainContent">
                    <IonRow>
                        <IonCol size="12">
                            {(articles && articles.length > 0) && articles.map((article, index) => (
                                <div key={index}>
                                    <h2 className="articleDetailTitle">{article.ident}</h2>
                                    {article &&
                                        <table className="articleDetailsTable">
                                            <tbody>
                                                <tr>
                                                    <td>Name</td>
                                                    <td>{article.name}</td>
                                                </tr>
                                                <tr>
                                                    <td>d<sub>1</sub></td>
                                                    <td>{article.d1_min}-{article.d1_max}</td>
                                                </tr>
                                                <tr>
                                                    <td>z</td>
                                                    <td>{article.z_min}-{article.z_max}</td>
                                                </tr>
                                                <tr>
                                                    <td>Typ</td>
                                                    <td>{article.ttype}</td>
                                                </tr>
                                                {article.besch && <tr>
                                                    <td>Beschichtung</td>
                                                    <td>{article.besch}</td>
                                                </tr>}
                                                {article.serie && <tr>
                                                    <td>Serie</td>
                                                    <td>{article.serie}</td>
                                                </tr>}
                                                <tr>
                                                    <td>Trocut</td>
                                                    <td>{article.trocut === "0" ? "Nein" : "Ja"}</td>
                                                </tr>
                                            </tbody>
                                        </table>}
                                </div>
                            ))}
                        </IonCol>
                    </IonRow>
                </IonGrid>

            </IonContent>
            <CustomLoading isOpen={loading} />
        </IonPage>
    )
}

export default ArticleDetail;